/**
 * analytics.js
 */

import ReactGA4 from 'react-ga4';
import Smartlook from 'smartlook-client';
import logger from 'utils/logger';
import { Types } from 'utils/constants';


//const enabled = process.env.REACT_APP_ENV !== 'development';
const enabled = !window.Cypress;

export default {
  initializeGA4: (user, activeDogCount) => {
    if (enabled) {
      const handlerSubscription = user
        .subscription
        .subscriptions
        .find(s => s.role.id === Types.Role.HANDLER);
      const userRole = user?.role?.name;
      const planType = handlerSubscription?.type?.name || 'N/A';

      ReactGA4.initialize('G-6QMC4719MY', {
        legacyDimensionMetric : false
      });
  
      ReactGA4.set({
        'user_properties': {
          'user_role': userRole,
          'user_plan_type': planType,
          'user_dog_count': activeDogCount
        }
      });

      logger.logAnalytics('[analytics.js] Initialized GA4');
    }
  },

  trackGA4: (event, args) => {
    if (enabled) {
      ReactGA4[event](args.name, args.params);
    }
  },

  initializeSmartlook: (user) => {
    const handlerSubscription = user
      .subscription
      .subscriptions
      .find(s => s.role.id === Types.Role.HANDLER);
    const userRole = user?.role?.name;
    const planType = handlerSubscription?.type?.name || 'N/A';

    Smartlook.init('b05ae8a5be77da22ea73a98850008069df876996');
    Smartlook.record({ forms: true, numbers: true, emails: true, ips: true });
    Smartlook.properties({
      plan_type: planType,
      role_type: userRole,
    }); 

    logger.logAnalytics('[analytics.js] Initialized Smartlook');
  }

}